import axiosWrapper from '@/utils/request'

const addBank = (exporterId, data) => {
  return axiosWrapper({
    url: `v1/business/exporters/${exporterId}/create_bank_account_details`,
    method: 'POST',
    data
  })
}

const updateBank = (exporterId, data) => {
  return axiosWrapper({
    url: `v1/business/exporters/${exporterId}/update_bank_account_details`,
    method: 'PATCH',
    data
  })
}

const removeBank = (buyerId, coverLetterInstructionId) => {
  return axiosWrapper({
    url: `v1/business/clients/${buyerId}/delete-cover-letter-instruction?cover_letter_instruction_id=${coverLetterInstructionId}`,
    method: 'PATCH'
  })
}

export const removeBankDocument = (exporterId, bankId, docId) => {
  return axiosWrapper({
    method: 'DELETE',
    url: `v1/business/exporters/${exporterId}/unlink_bank_detail_document`,
    data: {
      bank_detail_id: bankId,
      document_id: docId
    }
  })
}

export const removeExporterDocument = (exporterId, docId) => {
  return axiosWrapper({
    method: 'DELETE',
    url: `v1/onboarding/leads/${exporterId}/documents/${docId}`
  })
}

/**
 * @function fetchBankDetailsData
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 */
const fetchBankDetails = (token, account) => {
  return axiosWrapper({
    url: `/business/beneficiary_bank_details/${account}`,
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}

export default {
  addBank,
  updateBank,
  removeBank,
  fetchBankDetails,
  removeBankDocument,
  removeExporterDocument
}
